import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  CustomDateRangeChangeEventModel
} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range-change-event.model";
import {CustomDateRangeModel} from "@ui-kit/webkit/components/custom-date-filter/custom-date-range.model";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {DashboardUtilsService} from "../../dashboard-utils.service";
import {DashboardChart, DashboardPeriod} from "../../dashboards.model";

@Component({
  selector: 'app-dashboards-chart-section',
  templateUrl: './dashboards-chart-section.component.html',
  styleUrls: ['./dashboards-chart-section.component.scss']
})
export class DashboardsChartSectionComponent implements OnInit {
  @Input() sectionName!: string;

  @Input() chart1!: DashboardChart<any>;
  @Input() chart2?: DashboardChart<any>;

  @Input() dateFilterType!: "picker" | "custom-range";

  @Input() customDateRangePresets?: CustomDateRangeModel[];
  @Input() initialPreset?: string;
  @Input() dateRangeIndex?: number;

  @Input() pickerType?: "month" | "year" | "week";
  @Input() date1: Date = new Date();
  @Input() date2: Date = new Date();

  /**
   * Opt-in. This component backs every chart section on the report pages, so the Weekly/Monthly
   * toggle must be requested explicitly rather than appearing on all of them.
   */
  @Input() showPeriodToggle: boolean = false;
  @Input() period: DashboardPeriod = 'WEEKLY';

  @Output() dateRangeChanged = new EventEmitter<{event: CustomDateRangeChangeEventModel, index: number}>();

  @Output() datePickerClosed = new EventEmitter<void>();
  @Output() date1Change = new EventEmitter<Date>();
  @Output() date2Change = new EventEmitter<Date>();
  @Output() periodChange = new EventEmitter<DashboardPeriod>();

  chartStats1: string[] = [];
  chartStats2?: string[] = [];

  constructor(public dashboardUtils: DashboardUtilsService, public dateUtils: DateUtilsService) {
  }

  ngOnInit() {
    this.chartStats1 = Object.keys(this.chart1.stats);
    if (this.chart2) this.chartStats2 = Object.keys(this.chart2.stats);
  }

  getDateRange(event: CustomDateRangeChangeEventModel) {
    this.dateRangeChanged!.emit({event, index: this.dateRangeIndex!});
  }

  /**
   * Relays a picker's new date to the parent. Both halves matter: the local field keeps the
   * picker's own display in step, and the output is what actually reaches the report component —
   * without it the parent keeps querying its initial dates.
   */
  onDateChanged(date: Date, pickerIndex: number) {
    if (pickerIndex === 1) {
      this.date1 = date;
      this.date1Change.emit(date);
    } else {
      this.date2 = date;
      this.date2Change.emit(date);
    }
  }

  selectPeriod(period: DashboardPeriod) {
    if (period === this.period) return;
    this.period = period;
    this.periodChange.emit(period);
  }
}
